import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    IconButton,
    Tooltip
} from 'material-ui';
import EditIcon from 'material-ui-icons/Edit';
import DeleteIcon from 'material-ui-icons/Delete';
import RedirectDeleteDialog from './RedirectDeleteDialog';
import {
    deleteRedirect,
} from './thunks';
import {
    canEditOrViewGlobal,
    showDeleteGlobalButton,
    showViewGlobalButton
} from '../../components/permissions/permissions';

class RedirectsGridActions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            redirect: null
        };
    }

    handleClickOpen = (redirect) => {
        this.setState({
            open: true,
            redirect: redirect
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
            redirect: null
        });
    };

    deleteRedirect = (redirect) => {
        this.props.deleteRedirect(this.state.redirect);
        this.setState({
            open: false,
            redirect: null
        });
    };

    render() {
        const {props} = this.props;

        const EditButton = () => (
            <span>
                <Link to={"/redirects/" + props.row.id}>
                <Tooltip title="Edit Redirect">
                    <IconButton className="smallIconButton editColor">
                        <EditIcon />
                    </IconButton>
                </Tooltip>
                </Link>{' '}
            </span>
        )

        const ViewButton = showViewGlobalButton(() =>
            <span>
                No Actions
            </span>
        )

        const EditOrViewRedirect = canEditOrViewGlobal(EditButton, ViewButton);

        const DeleteRedirectButton = showDeleteGlobalButton(() =>
            <span>
                <Tooltip title="Delete Redirect">
                    <IconButton className="smallIconButton deleteColor" onClick={e => this.handleClickOpen(props.row.id)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </span>
        )

        return(
            <span>
                <EditOrViewRedirect />
                <DeleteRedirectButton />
                <RedirectDeleteDialog
                    open={this.state.open}
                    handleSubmit={this.deleteRedirect.bind(this)}
                    handleRequestClose={this.handleRequestClose}
                />
            </span>
        )
    }
}

const mapStateToProps = (state, props) => ({});

export default connect(mapStateToProps, {
    deleteRedirect,
})(RedirectsGridActions);


// WEBPACK FOOTER //
// ./src/containers/redirects/RedirectsGridActions.jsx